import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/PerimeterRollingAndSliding/Sliding/1_1x.png`;
const Pic2 = `${FullPath}/PerimeterRollingAndSliding/Sliding/2_1x.png`;
const Pic3 = `${FullPath}/PerimeterRollingAndSliding/Sliding/3_1x.png`;
const Pic4 = `${FullPath}/PerimeterRollingAndSliding/Sliding/4_1x.png`;
const Pic5 = `${FullPath}/PerimeterRollingAndSliding/Sliding/5_1x.png`;
const Pic6 = `${FullPath}/PerimeterRollingAndSliding/Sliding/6_1x.png`;
const Pic7 = `${FullPath}/PerimeterRollingAndSliding/Sliding/7_1x.png`;
const Pic8 = `${FullPath}/PerimeterRollingAndSliding/Sliding/8_1x.png`;
const Pic9 = `${FullPath}/PerimeterRollingAndSliding/Sliding/9_1x.png`;




export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
      
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}